"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BufferedReader = /** @class */ (function () {
    /**
     *
     */
    function BufferedReader(data) {
        if (data === void 0) { data = ""; }
        this.m_pointer = 0;
        this.m_lines = Array.from(data.replace(/\r/gi, "").split('\n'));
    }
    BufferedReader.prototype.readLine = function () {
        if (this.m_pointer >= this.m_lines.length)
            return null;
        return this.m_lines[this.m_pointer++];
    };
    return BufferedReader;
}());
exports.default = BufferedReader;

//# sourceMappingURL=BufferedReader.js.map
